import { Directive } from '@angular/core';
import { Operator, RelationalLogicalOperator } from '../../dataModels';

@Directive({ selector: 'filter-part' })
export class FilteredListFilterPartDirective { }

@Directive({ selector: 'scroll-part' })
export class FilteredListScrollPartDirective { }






const DATA_REL = "data-rel";
const DATA_IGNORE = "data-ignore";
const DATA_INDEX = "data-index";
const DATA_OPERATOR = "data-operator";


export function isInputIncluded(input) {
    if (!input || input.hasAttribute(DATA_IGNORE)) {
        return false;
    }

    if (input.type === 'submit') {
        return false;
    }

    if (input.type === 'radio' && !input.checked) {
        return false;
    }

    if (input.type !== 'select' && !input.name) {
        console.warn("unnamed input will be skipped");
        return false;
    }

    if (String(input.value) === 'undefined' || String(input.value) === 'null' || input.value == '') {
        return false;
    }

    return true;
}

export function getOperator(input: any): Operator {
    let attribute = input.getAttribute(DATA_OPERATOR);
    attribute = attribute = (typeof attribute === 'string') ? attribute : '';
    attribute = attribute.trim().toLowerCase();

    let op = Operator.Contains;

    switch (attribute) {
        case 'e': case 'eq': case 'equal': case 'equals':
            op = Operator.Equal; break;
        case 'g': case 'gt': case 'greater': case 'greaterthan':
            op = Operator.GreaterThan; break;
        case 'ge': case 'gte': case 'greaterequal': case 'greaterthanequal':
            op = Operator.GreaterThanOrEqual; break;
        case 'l': case 'lt': case 'less': case 'lessthan':
            op = Operator.LessThan; break;
        case 'le': case 'lte': case 'lessequal': case 'lessthanequal':
            op = Operator.LessThanOrEqual; break;
        case 'n': case 'not':
            op = Operator.NotEqual; break;
    }

    return op;
}

export function getRelationalOperator(input: any): RelationalLogicalOperator {
    let attribute = input.getAttribute(DATA_REL);
    attribute = (typeof attribute === 'string') ? attribute : '';
    attribute = attribute.trim().toLowerCase();

    if (attribute === 'or') {
        return RelationalLogicalOperator.Or
    } else {
        return RelationalLogicalOperator.And;
    }
}


export function getIndex(input: any): number {
    let index = +input.getAttribute(DATA_INDEX);
    if (isNaN(index)) {
        index = 1e25;
    }

    return index;
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/filteredList/filtered-list-parts.ts